import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handle = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await axios.post('/api/auth/login', form);
      login(data.token, data.user);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Eroare la autentificare');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-box">
        <div className="auth-logo">Anxio.co</div>
        <div className="auth-tagline">Bine ai revenit. Respiră și intră în cont.</div>
        <form onSubmit={submit}>
          <div className="form-group">
            <label className="input-label">EMAIL</label>
            <input className="input" name="email" type="email" value={form.email} onChange={handle} placeholder="tu@exemplu.ro" required />
          </div>
          <div className="form-group">
            <label className="input-label">PAROLĂ</label>
            <input className="input" name="password" type="password" value={form.password} onChange={handle} placeholder="••••••" required />
          </div>
          {error && <div className="error-msg" style={{ marginBottom: 12 }}>{error}</div>}
          <button className="btn btn-primary btn-full" disabled={loading}>
            {loading ? 'Se încarcă...' : 'Intră în cont'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: 12, fontSize: 13 }}>
          <a href="/reset-password.html" style={{ color: 'var(--muted)' }}>Ai uitat parola?</a>
        </p>
        <p style={{ textAlign: 'center', marginTop: 16, fontSize: 13, color: 'var(--muted)' }}>
          Nu ai cont?{' '}
          <Link to="/register" style={{ color: 'var(--teal)', fontWeight: 600 }}>Înregistrează-te</Link>
        </p>
      </div>
    </div>
  );
}